import flexposApiService from './flexposApiService';

export default flexposApiService;
